// Shared loader for the admin-managed Quick Menu.
//
// Both FloatingQuickMenu (desktop) and MobileFloatingQuickMenu (mobile) are
// mounted at once in App and each used to GET /quick-menu independently — two
// identical requests on every page load. This module dedupes them: the first
// caller triggers the request, the rest await the same in-flight promise, and
// the resolved payload is reused for the rest of the session.
//
// Contract is unchanged: returns { items, settings }. Network errors resolve to
// a safe empty payload (callers already fall back to static defaults) and are
// NOT cached, so a later mount can retry.

import api from '../api/api'

let cached = null
let inFlight = null

export const loadQuickMenu = () => {
  if (cached) return Promise.resolve(cached)
  if (inFlight) return inFlight

  inFlight = api.get('/quick-menu')
    .then(({ data }) => {
      const payload = data?.success
        ? { items: data.items || [], settings: data.settings || {} }
        : { items: [], settings: {} }
      if (data?.success) cached = payload // only cache real success responses
      return payload
    })
    .catch(() => ({ items: [], settings: {} }))
    .finally(() => { inFlight = null })

  return inFlight
}
